import axios from "axios";

export default function getAllAuditRecords() {
  return axios("/api/Audit/all", {
    method: "GET",
  });
}

export function getAuditRecordById(id: number) {
  return axios(`/api/Audit/${id}`, {
    method: "GET",
  });
}

export function getAuditRecordByAuditTypeAndIdentity(
  objectType: string,
  objectIdentifier: string
) {
  return axios(`/api/Audit/type/${objectType}/identity/${objectIdentifier}`, {
    method: "GET",
  });
}

export function getAuditRecordsByAuditType(objectType: string) {
  return axios(`/api/Audit/type/${objectType}`, {
    method: "GET",
  });
}

export function setComment(auditId: number, commentToSave: string) {
  return axios(`/api/Audit/${auditId}/comment`, {
    method: "POST",
    data: { Data: commentToSave },
  });
}

export function getAuditSummary(auditId: number) {
  return axios(`/api/Audit/${auditId}/summary`, {
    method: "GET",
  });
}

export function getAllObjectTypes() {
  return axios("/api/Audit/allObjectTypes", {
    method: "GET",
  });
}
